import InitTrialClientsLogic, { TrialClientRow } from "./TrialClients.logic";
import { formatBookingDate as formatDate, formatBookingTime as formatTime } from "../../helpers/dateFormat";
import styles from "./TrialClients.module.css";

const STATUS_OPTIONS = [
  { value: "", label: "Bez statusa" },
  { value: "na_cekanju", label: "Na čekanju" },
  { value: "ne_nastavlja", label: "Ne nastavlja" },
];

const TrialClientsComponent: React.FC = () => {
  const { rows, loading, savingId, onChangeStatus, onBack } = InitTrialClientsLogic();

  if (loading) {
    return (
      <div className="page-container">
        <p className={styles.empty}>Učitavanje...</p>
      </div>
    );
  }

  const renderStatus = (row: TrialClientRow) => {
    // Otkazan termin ne prikazujemo kao "Zakazan probni" - admin može odmah
    // da vodi status (npr. Na čekanju dok se ne zakaže novi probni).
    if (row.upcoming && !row.cancelled) {
      return <span className={`${styles.badge} ${styles.badgeUpcoming}`}>Zakazan probni</span>;
    }
    if (row.continued) {
      return <span className={`${styles.badge} ${styles.badgeContinued}`}>Nastavio treninge</span>;
    }
    return (
      <select
        className={styles.statusSelect}
        aria-label="Status probnog klijenta"
        value={row.trialStatus ?? ""}
        disabled={savingId === row.id}
        onChange={(e) => onChangeStatus(row.id, e.target.value === "" ? null : e.target.value)}
      >
        {STATUS_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
    );
  };

  return (
    <div className="page-container">
      <h1 className={styles.title}>Probni klijenti</h1>
      <p className={styles.count}>Ukupno probnih zakazivanja: {rows.length}</p>

      {rows.length === 0 && (
        <p className={styles.empty}>Još nema klijenata zakazanih kao probni.</p>
      )}

      {rows.map((row) => (
        <div key={row.id} className={styles.card}>
          <div className={styles.cardHeader}>
            <span className={styles.name}>{row.clientName}</span>
            <span className={styles.date}>
              {formatDate(row.date)} {formatTime(row.date)}
            </span>
          </div>
          <p className={styles.detail}>Lokacija: {row.location}</p>
          <p className={styles.detail}>
            Trener na probnom: {row.trainerName ?? "nije određen"}
          </p>
          <div className={styles.statusRow}>
            {renderStatus(row)}
            {row.cancelled && (
              <span className={`${styles.badge} ${styles.badgeCancelled}`}>Termin otkazan</span>
            )}
          </div>
        </div>
      ))}

      <button
        type="button"
        className="btn-secondary"
        style={{ marginTop: 20 }}
        onClick={onBack}
      >
        Nazad
      </button>
    </div>
  );
};

export default TrialClientsComponent;
